<template>
    <table ref="table" class="table table-hover table-vcenter table-bordered dataTable block-list">
        <thead>
            <tr>
                <th>ID</th>
                <th>Bidder Code</th>
                <th>Advertiser</th>
                <th>Dimensions</th>
                <th>Status</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script setup>
import { onMounted, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
});

const table = ref();

onMounted(() => {
    const dataTable = window.jQuery(table.value).dataTable({
        processing: true,
        serverSide: true,
        ajax: {
            url: props.ajaxUrl,
        },
        order: [0, "desc"],
        pageLength: 25,
        columns: [
            {
                data: 'id',
                searchable: false,
            },
            {
                data: 'bidder_code',
            },
            {
                data: 'advertiser_name',
            },
            {
                data: 'dimensions',
                render: (data, type, row) => row.dimensions?.length ?? 0,
                searchable: false,
                orderable: false,
            },
            {
                data: 'status',
                searchable: false,
            },
            {
                name: 'created_by',
                render: (data, type, row) => row.user?.name ?? '-',
                searchable: false,
                orderable: false,
            },
            {
                data: 'created_at',
                searchable: false,
            },
            {
                data: 'actions',
                orderable: false,
                searchable: false,
            },
        ],
    });
});
</script>
